import type { FC } from 'react';

interface PageNoteFoundProps {}

const PageNoteFound: FC<PageNoteFoundProps> = () => {
    return (
        <div>
            
        </div>
    );
}

export default PageNoteFound;
